import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

export const containerStyle = style({
  paddingTop: rem(4),
});
